export default __webpack_public_path__ + "static/media/MCSW-CareerImage.ff1b72bc.png";